import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useSignIn } from 'react-auth-kit';
import history from '../../../../../history';
import { SetLocalStorage } from '../../../../misc/UseLocalStorage';

interface State {
  name: string;
  email: string;
}
interface ContextType {
  state: State;
  handleDoLogin: () => void;
  switchToken: (code) => void;
}

const initialState: State = {
  name: '',
  email: '',
};

const Context = React.createContext<ContextType>({
  state: initialState,
  handleDoLogin: () => {},
  switchToken: () => {},
});
const { Provider: SsoSimpatikaProvider } = Context;

const Provider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const signIn = useSignIn();
  const location = useLocation();
  const [state] = React.useState<State>(initialState);

  const queryParams = new URLSearchParams(location.search);

  const handleDoLogin = () => {
    window.location.href = `${process.env.REACT_APP_SIMPATIKA_URL}oauth/authorize?client_id=${process.env.REACT_APP_SIMPATIKA_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_SIMPATIKA_REDIRECT_URI_1}&response_type=code&scope=read`;
  };

  React.useEffect(() => {
    if (location.pathname === '/') {
      const oauthCode = queryParams.get('code');

      switchToken(oauthCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const getMe = async (token: string) => {
    const baseUrl = process.env.REACT_APP_BE_PROD_BASE_URL;

    const res = await axios.get(baseUrl + 'auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const { data } = res.data;

    return data;
  };

  const switchToken = async (code) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BE_PROD_BASE_URL}simpatika/switch-token`,
        {
          st_code: code,
        }
      );

      const { data } = response?.data;

      const user = {
        id: data.id,
        username: data?.name,
        nik: data?.nik,
        email: data?.email,
        level: data?.level,
        jenis_user: data?.jenis_user,
      };

      const responseMe = await getMe(data?.access_token);

      // set foto profile
      SetLocalStorage({
        name: 'path_photo',
        value: responseMe?.path_foto,
      });

      // set level
      SetLocalStorage({ name: 'level', value: responseMe.level });

      // set status pengisian
      SetLocalStorage({
        name: 'status_pengisian',
        value: responseMe?.m_peserta?.status_pengisian,
      });

      // return;
      if (
        signIn({
          token: data?.access_token,
          expiresIn: data?.expires_in,
          tokenType: 'Bearer',
          authState: user,
        })
      ) {
        history.replace('/');
      }
    } catch (error) {
      const message = error.response?.data?.message || '';

      if (message.toLowerCase() === 'user not found') {
        window.location.href = '/register';
      }
    }
  };

  const contextValue: ContextType = {
    state,
    handleDoLogin,
    switchToken,
  };

  return (
    <SsoSimpatikaProvider value={contextValue}>{children}</SsoSimpatikaProvider>
  );
};

export const useSsoSimpatikaContext = () => React.useContext(Context);

const SsoSimpatika = {
  useSsoSimpatikaContext,
  Provider,
};

export default SsoSimpatika;
